<form [formGroup]="commentForm">
  <mat-form-field class="full-w">
    <mat-label>{{ "mydrugs.comment" | translate }}</mat-label>
    <textarea class="h-75" formControlName="comment" matInput></textarea>
  </mat-form-field>
</form>
